export const howWeTeach = {
  title: "Cómo Enseñamos",
  subtitle: "Metodologías que guían nuestro día a día",
  items: {
    active: {
      title: "Pedagogía Activa / Montessori",
      description: "El niño como protagonista de su aprendizaje a través de ambientes preparados y materiales manipulativos"
    },
    global: {
      title: "Aprendizaje Global en Inglés",
      description: "Inmersión progresiva: 40% en Infantil, 45% en Ciclo 1, 50% en Ciclo 2, con áreas no lingüísticas en inglés"
    },
    inclusion: {
      title: "Inclusión (DUA)",
      description: "Diseño Universal de Aprendizaje que garantiza accesibilidad y respeta la diversidad de cada estudiante"
    },
    evaluation: {
      title: "Evaluación Amable",
      description: "Datos amables: observación, documentación pedagógica y feedback que acompaña sin etiquetar"
    }
  }
};
